import { useResolveRooms } from '@/dc-shared-web/src'

import NotificationResolvedUserName from '@/app/core/components/notification/NotificationResolvedUserName'

export default function NotificationTitle({
  involvedUsers,
  isMentionNotification,
  roomId,
}: {
  involvedUsers: string[]
  isMentionNotification: boolean
  roomId: string
}) {
  const { data, isLoading } = useResolveRooms([roomId])

  return isLoading ? (
    <div className='tw-grow tw-h-6 tw-animate-skeleton-shimmer' />
  ) : (
    <div className='tw-break-inner tw-text-sm'>
      {involvedUsers.length === 1 && (
        <NotificationResolvedUserName
          userId={involvedUsers[0]}
          className='tw-font-medium'
        />
      )}
      {involvedUsers.length === 2 && (
        <>
          <NotificationResolvedUserName
            userId={involvedUsers[0]}
            className='tw-font-medium'
          />
          {' and '}
          <NotificationResolvedUserName
            userId={involvedUsers[1]}
            className='tw-font-medium'
          />
        </>
      )}
      {involvedUsers.length > 2 && (
        <>
          <NotificationResolvedUserName
            userId={involvedUsers[0]}
            className='tw-font-medium'
          />
          {` and ${involvedUsers.length - 1} others`}
        </>
      )}
      {isMentionNotification ? ` mentioned you` : ` commented`}
      {` on `}
      <span className='tw-font-medium'>{data![0]?.checklistName}</span>
      {` in `}
      <span className='tw-font-medium'>{data![0]?.crunchName}</span>
    </div>
  )
}
